export default __webpack_public_path__ + "static/step_filter-ae70c959bf81f2e4db672a15a8661011.webp";